import axios from "@/util/axios";

function getCacheBuster() {
  return Date.now().toString();
}

const defaultOptions = {
  getCacheBuster,
};

// TODO should we only send response.data
// TODO we should probably use cache buster get and head

export function assert(condition, msg) {
  if (!condition) {
    throw new Error(msg);
  }
  return true;
}

export function assertId(id) {
  return assert(id != null && id !== "", "id must not be undefined, null or ''");
}

export function assertNumber(num) {
  return assert(typeof num === "number", "not a number: " + JSON.stringify(num));
}

export function assertObject(o, msg) {
  return assert(typeof o === "object", msg);
}

export function assertUrl(o, msg) {
  return assert(typeof o === "string", msg);
}

export function assertData(data) {
  return assert(data != null, "Record data must not be undefined or null");
}

export const existsRecord = async (methodOptions, collectionUrl, id) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  try {
    const options = { ...defaultOptions, ...methodOptions };
    assertId(id);
    await axios.head(`${collectionUrl}/${encodeURIComponent(id)}?_=${options.getCacheBuster()}`);
    return true;
  } catch (err) {
    return false;
  }
};

export const existRecords = async (methodOptions, collectionUrl, query) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  try {
    const options = { ...defaultOptions, ...methodOptions };
    const data = await fetchRecords(options, collectionUrl, query);
    const records = data.records;
    return records.length > 0;
  } catch (err) {
    return false;
  }
};

export const fetchRecords = async (methodOptions, collectionUrl, query) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  const options = { ...defaultOptions, ...methodOptions };
  const response = await axios.get(`${collectionUrl}`, { params: { q: query, _: options.getCacheBuster() } });
  return response.data;
};

export const fetchRecord = async (methodOptions, collectionUrl, id) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  assertId(id);
  const options = { ...defaultOptions, ...methodOptions };
  const response = await axios.get(`${collectionUrl}/${encodeURIComponent(id)}?_=${options.getCacheBuster()}`);
  return response.data;
};

export const deleteRecord = async (methodOptions, collectionUrl, id) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  assertId(id);
  const response = await axios.delete(`${collectionUrl}/${encodeURIComponent(id)}`);
  return response.data;
};

export const updateRecord = async (methodOptions, collectionUrl, id, data) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  assertId(id);
  assertData(data);
  const response = await axios.put(`${collectionUrl}/${encodeURIComponent(id)}`, data);
  return response.data;
};

export const insertRecord = async (methodOptions, collectionUrl, data) => {
  assertObject(methodOptions, "methodOptions is not an object");
  assertUrl(collectionUrl, "collectionUrl is not a string");
  assertData(data);
  const response = await axios.post(`${collectionUrl}/`, data);
  return response.data;
};
